module.exports = __webpack_public_path__ + "img/1-02.16fa66bd.svg";